import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class LoansLobbyService {
  abstract getLoanLobbyDetails(): Observable<IResponse<ILoanLobbyResult>>;
  abstract createLeadToAgent(leadDetails: any): Observable<IResponse<number>>;
  abstract getLeadToAgentSuccessIconUrl(): string;
  abstract getIsPersonal(): boolean;
  abstract getLeadToAgentFailIconUrl(): string;
  abstract getQAndAExpandIconUrl(): string;
  abstract getQAndACollapseIconUrl(): string;
  abstract pushToGtmLoansLobby(action: string, label: string): void;
  abstract pushToGtmCustomerLoan(
    action: string,
    label: string,
    step: string
  ): void;
}

export interface ILoanLobbyResult {
  loansLobbySiteType: LoansLobbySiteType;
  pageTitle: string;
  pageDescription: string;
  loansCalculator: ILoansCalculatorResult;
  menuAndLoanReasons: IMenuAndLoanReasonsResult;
  leadToAgent: ILeadToAgentResult;
  questionsAndAnswersContainer: IQuestionsAndAnswersContainerResult;
  additionalInfoContainer: IAdditionalInfoContainerResult;
  isPersonal: boolean;
  asterix: string;
}

export enum LoansLobbySiteType {
  Online,
  Business
}

export interface ILoansCalculatorResult {
  mainBannerImage: ILcImage;
  mainBannerTitle: string;
  mainBannerTitleReg: string;
  mainBannerTitleForMobile: string;
  mainBannerTitleRegForMobile: string;
  mainBannerSubTitle: string;
  defaultLoanAmount: number;
  defaultLoanText: string;
  minimumLoanAmount: number;
  maximumLoanAmount: number;
  minimumLoanPayments: number;
  maximumLoanPayments: number;
  defaultInterest: number;
  primeInterest: number;
  loanPaymentsNum1: number;
  loanPaymentsNum2: number;
  loanPaymentsNum3: number;
  textAboveButton: string;
  mainBannerButtonText: string;
  mainBannerButtonLink: string;
  mainBannerButtonColor: string;
  mainBannerLegalText: string;
  mainBannerImageForMobile: ILcImage;
  mainBannerButtonLinkPersonal: string;
  loanAmountTextColor: string;
}

export interface IMenuAndLoanReasonsResult {
  menuTitle1: string;
  menuTitle2: string;
  menuTitle3: string;
  menuTitle4: string;
  loanReasonsContainer: ILoanReasonsContainerResult;
}

export interface ILoanReasonsContainerResult {
  loanReasonsTitle: string;
  loanReasons: ILoanReasonResult[];
}

export interface ILoanReasonResult {
  loanReasonImage: ILcImage;
  loanReasonTitle: string;
  loanReasonSubTitle: string;
}

export interface ILeadToAgentResult {
  leadTitle: string;
  leadSubTitle: string;
  leadColor: string;
  leadButtonText: string;
  leadButtonColor: string;
  leadWhatsappText: string;
  leadClicktoCallText: string;
  leadClicktoCallPhoneNumber: string;
  operatingTimeWeekdayOpenHour: string;
  operatingTimeWeekdayCloseHour: string;
  operatingTimeFridayOpenHour: string;
  operatingTimeFridayCloseHour: string;
  maximumLoan: number;
}

export interface IQuestionsAndAnswersContainerResult {
  qnaTitle: string;
  allQNALinkText: string;
  allQNALinkUrl: string;
  questionsAndAnswers: IQuestionAndAnswerResult[];
}

export interface IQuestionAndAnswerResult {
  questionText: string;
  answerText: string;
}

export interface IAdditionalInfoContainerResult {
  additionalInfoMainTitle: string;
  additionalInfoLinkText: string;
  additionalInfoList: IAdditionalInfoResult[];
}

export interface IAdditionalInfoResult {
  additionalInfoImage: ILcImage;
  additionalInfoTitle: string;
  additionalInfoText: string;
  additionalInfoLinkText: string;
  additionalInfoLinkUrl: string;
}

/////////
export interface ILcImage {
  url: string;
  alt: string;
}

export class LoanLobbyResult implements ILoanLobbyResult {
  asterix: string;
  loansLobbySiteType: LoansLobbySiteType;
  pageTitle: string;
  pageDescription: string;
  loansCalculator: ILoansCalculatorResult;
  menuAndLoanReasons: IMenuAndLoanReasonsResult;
  leadToAgent: ILeadToAgentResult;
  questionsAndAnswersContainer: IQuestionsAndAnswersContainerResult;
  additionalInfoContainer: IAdditionalInfoContainerResult;
  isPersonal: boolean;
}

export interface IResponse<T> {
  result: T;
  returnCode?: number;
  rcDesc: string;
  correlationID: string;
}
